import { render, staticRenderFns } from "./Day23.vue?vue&type=template&id=5387c3ed"
import script from "./Day23.vue?vue&type=script&lang=js"
export * from "./Day23.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports